import React from 'react';

import Header from '../../layout/Header.jsx';
import ListHorses from '../../lists/ListHorses.jsx';

const PageHorses = () => (
  <div>
    <Header>Horses</Header>
    <ListHorses />
  </div>
);

export default PageHorses;
